import React from "react";
import { TriangleAlert } from 'lucide-react'
//import formatTime from '../../../../../utils/formatTime'

interface ListCardProps {
    title: string;
    subtitle: string;

    titleStyle?: string;

    icon?: React.ReactNode;
    iconContainer?: boolean

    time?: string;
    severity?: string;
    isRead?: boolean
    expanded?: boolean
};

export default function ListCard({
    title,
    titleStyle,
    subtitle,
    time,
    severity,
    icon = <TriangleAlert size={28} className="text-white" />,
    iconContainer = true }: ListCardProps) {

    //const formattedTime = formatTime(time)

    return (
        <div className="rounded flex items-center gap-4">
            {/* Left Icon */}
            <div className={`${iconContainer ? 'logo-container' : ''} relative`}>
                {icon}

                {/* Red alert badge */}
                {severity == "high" && (
                    <div className="w-3 h-3 absolute top-0 -right-1 bg-orange-400 rounded-full p-[2px]">
                    </div>
                )}
            </div>

            {/* Text Content */}
            <div className="flex flex-col w-full justify-center font-medium">
                <div className="flex justify-between items-center w-full">
                    <span className={`${titleStyle === 'underline' && 'underline'} font text-gray-800 line-clamp-1`}>
                        {title}
                    </span>
                    {time &&
                        <span className="text-sm text-gray-500 whitespace-nowrap ml-2">
                            {time}
                        </span>
                    }
                </div>
                <span className={`text-left text-gray-500 text-sm mt-0.5`}>
                    {subtitle}
                </span>
            </div>
        </div>
    );
}
